/**
 * MuseStand Pet Bowl Set 图片切换系统
 * 直接从 CDN 加载预渲染的组合图片
 * 命名规则: 
 * - MuseStand Bowl Set: bowl1_top_{TopColor}_{TopFinish}_bottom_{BottomColor}_{BottomFinish}.jpg
 * - AccoGift Feeding Set: bowl1_top_{TopColor}_{TopFinish}_bottom_{BottomColor}_{BottomFinish}_mat_{MatColor}.jpg
 */

(function() {
  'use strict';

  console.log('🥣 [MuseStandBowl] 脚本开始加载...');

  // ========== 配置 ==========
  const PRODUCT_NAME = 'MuseStand Pet Bowl Set';
  const ACCOGIFT_PRODUCT_NAME = 'AccoGift Feeding Set';
  const CDN_BASE_URL = 'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/';
  const CDN_VERSION = '?v=1764191491';

  // 颜色名称映射
  const COLOR_MAP = {
    'White': 'white',
    'Black': 'black',
    'Pink': 'pink',
    'Baby Blue': 'babyblue',
    'BabyBlue': 'babyblue',
    'Yellow': 'babyyellow',  // 🎯 修复：碗的 Yellow 颜色应该映射到 babyyellow
    'Cyan': 'cyan',
    'Navy Blue': 'navyblue',
    'NavyBlue': 'navyblue',
    'Navy': 'navyblue',  // Globo插件使用的简写
    'Orange': 'orange',
    'Green': 'green',
    'Purple': 'purple',
    'PurpleHaze': 'purplehaze',  // 图片文件名是 purplehaze
    'Purple Haze': 'purplehaze',
    'Red': 'red',
    'Brown': 'brown'
  };

  // 垫子颜色映射（Feeding Mat Color）
  const MAT_COLOR_MAP = {
    'BabyBlue': 'babyblue',
    'Baby Blue': 'babyblue',
    'Blue': 'babyblue',
    'Yellow': 'babyyellow',  // 🎯 修复：Yellow 应该映射到 babyyellow
    'BabyYellow': 'babyyellow',
    'Baby Yellow': 'babyyellow',
    'Black': 'black',
    'White': 'white'
  };
  
  // 垫子图片 CDN URL
  const MAT_CDN_BASE_URL = 'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/';
  const MAT_CDN_VERSION = '?v=1764279514';

  // ========== 工具函数 ==========
  
  // 防抖计时器
  let updateTimer = null;
  // 当前正在更新的标记
  let isUpdating = false;
  // 上次更新的组合（用于避免重复更新）
  let lastUpdateKey = '';

  function isCustomizePage() {
    return document.querySelector('.custom-builder') !== null;
  }

  // 检测当前产品类型
  function getProductType() {
    // Customize 页面
    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect && productSelect.options.length > 0) {
        const selectedOption = productSelect.options[productSelect.selectedIndex];
        if (selectedOption) {
          const selectedName = selectedOption.textContent.trim();
          const selectedHandle = selectedOption.value;
          
          if (selectedName.includes('AccoGift') && (selectedName.includes('Feeding Set') || selectedName.includes('Feeding'))) {
            return 'accogift-feeding-set';
          }
          if (selectedName.includes('MuseStand Pet Bowl') || selectedHandle.includes('musestand')) {
            return 'musestand-bowl';
          }
        }
      }
      return null;
    }

    // 产品页面
    const url = window.location.href.toLowerCase();
    const pageTitle = document.title.toLowerCase();
    
    if ((url.includes('accogift') && (url.includes('feeding') || url.includes('feeding-set'))) ||
        (pageTitle.includes('accogift') && (pageTitle.includes('feeding') || pageTitle.includes('feeding set')))) {
      return 'accogift-feeding-set';
    }
    
    if ((url.includes('musestand') && url.includes('bowl')) || pageTitle.includes('musestand pet bowl')) {
      return 'musestand-bowl';
    }
    // 🎯 SEO 改动：产品 handle 可能改为 dual-color-bowl，页面标题也可能变化，需兼容
    if (url.includes('dual-color-bowl')) {
      return 'musestand-bowl';
    }

    return null;
  }

  function shouldRun() {
    console.log('🥣 [MuseStandBowl] shouldRun() 检查中...');
    
    const productType = getProductType();
    if (productType) {
      console.log(`✅ [MuseStandBowl] 产品类型: ${productType}`);
      return true;
    }

    console.log('⏭️ [MuseStandBowl] 不是 MuseStand Bowl 或 AccoGift Feeding Set 产品');
    return false;
  }

  /**
   * 从选项值中解析颜色和 finish
   * 例如: "White (Matte)" -> { color: "white", finish: "matte" }
   *       "Black (Glossy)" -> { color: "black", finish: "glossy" }
   *       "White" -> { color: "white", finish: "glossy" } (默认)
   */
  function parseColorAndFinish(value) {
    if (!value) return { color: null, finish: 'glossy' };
    
    // 移除括号和 finish 信息
    const finishMatch = value.match(/\((\w+)\)/i);
    let finish = 'glossy'; // 默认值
    if (finishMatch) {
      const finishValue = finishMatch[1].toLowerCase();
      finish = finishValue.includes('matte') ? 'matte' : 'glossy';
    }
    
    // 提取颜色名称（移除括号部分）
    let colorName = value.replace(/\([^)]*\)/g, '').trim();
    
    // 标准化颜色名称
    const normalizedColor = normalizeColorName(colorName);
    
    return { color: normalizedColor, finish: finish };
  }
  
  /**
   * 标准化颜色名称（不包含 finish）
   */
  function normalizeColorName(name) {
    if (!name) return null;
    if (COLOR_MAP[name]) return COLOR_MAP[name];
    
    const normalized = name.toLowerCase().replace(/\s+/g, '');
    
    // 🎯 特殊处理：purplehaze -> purplehaze（保持原样）
    if (normalized.includes('purplehaze') || normalized.includes('purple-haze')) {
      return 'purplehaze';
    }
    
    for (const key in COLOR_MAP) {
      if (key.toLowerCase().replace(/\s+/g, '') === normalized) {
        return COLOR_MAP[key];
      }
    }
    return normalized;
  }
  
  /**
   * 兼容旧代码的 normalizeColor 函数
   */
  function normalizeColor(name) {
    const parsed = parseColorAndFinish(name);
    return parsed.color;
  }

  function normalizeMatColor(name) {
    if (!name) return null;
    if (MAT_COLOR_MAP[name]) return MAT_COLOR_MAP[name];
    
    const normalized = name.toLowerCase().replace(/\s+/g, '');
    for (const key in MAT_COLOR_MAP) {
      if (key.toLowerCase().replace(/\s+/g, '') === normalized) {
        return MAT_COLOR_MAP[key];
      }
    }
    // 如果不在映射中，尝试直接使用（小写，无空格）
    return normalized;
  }

  function parseFinishValue(value) {
    if (!value) return { top: 'glossy', bottom: 'glossy' };

    // 🎯 清除箭头符号和emoji（Globo插件可能添加的）
    const cleanValue = value.replace(/⬆️|⬇️|↑|↓|🔺|🔻/g, '').trim();
    
    const parts = cleanValue.toLowerCase().split('+');
    let topFinish = 'glossy';
    let bottomFinish = 'glossy';

    if (parts.length >= 2) {
      topFinish = parts[0].trim().includes('matte') ? 'matte' : 'glossy';
      bottomFinish = parts[1].trim().includes('matte') ? 'matte' : 'glossy';
    } else {
      const finish = cleanValue.toLowerCase().includes('matte') ? 'matte' : 'glossy';
      topFinish = finish;
      bottomFinish = finish;
    }

    return { top: topFinish, bottom: bottomFinish };
  }

  /**
   * 生成碗的图片 URL
   */
  function generateBowlImageUrl(topColor, bottomColor, finish) {
    if (!topColor || !bottomColor) {
      console.warn('⚠️ [MuseStandBowl] 碗颜色信息不完整', { topColor, bottomColor });
      return null;
    }

    // finish 可能是字符串 "matte+glossy" 或对象 { top: 'matte', bottom: 'glossy' }
    let topFinish, bottomFinish;
    if (typeof finish === 'string') {
      const finishes = parseFinishValue(finish);
      topFinish = finishes.top;
      bottomFinish = finishes.bottom;
    } else {
      topFinish = finish.top || 'glossy';
      bottomFinish = finish.bottom || 'glossy';
    }
    
    // 命名规则: bowl1_top_{TopColor}_{TopFinish}_bottom_{BottomColor}_{BottomFinish}.jpg
    const filename = `bowl1_top_${topColor}_${topFinish}_bottom_${bottomColor}_${bottomFinish}.jpg`;
    const url = `${CDN_BASE_URL}${filename}${CDN_VERSION}`;
    
    console.log('🥣 [MuseStandBowl] 生成碗图片URL:', url);
    return url;
  }
  
  /**
   * 生成垫子图片 URL
   */
  function generateMatImageUrl(matColor) {
    const normalizedMatColor = normalizeMatColor(matColor);
    if (!normalizedMatColor) {
      console.warn('⚠️ [MuseStandBowl] 垫子颜色无效:', matColor);
      return null;
    }
    
    // 垫子图片命名规则: mat_{MatColor}.jpg 或 mat_{MatColor}.png
    // 先尝试 .jpg，如果失败再尝试 .png
    const jpgUrl = `${MAT_CDN_BASE_URL}mat_${normalizedMatColor}.jpg${MAT_CDN_VERSION}`;
    const pngUrl = `${MAT_CDN_BASE_URL}mat_${normalizedMatColor}.png${MAT_CDN_VERSION}`;
    
    console.log('🎁 [MuseStandBowl] 生成垫子图片URL:', jpgUrl);
    return { jpg: jpgUrl, png: pngUrl };
  }
  
  /**
   * 生成图片 URL（兼容旧代码）
   */
  function generateImageUrl(options) {
    const productType = getProductType();
    
    if (productType === 'accogift-feeding-set') {
      // AccoGift Feeding Set: 使用图层叠加，这里返回 null，由专门的函数处理
      return null;
    } else {
      // MuseStand Bowl Set: 只有碗的图片
      return generateBowlImageUrl(options.topColor, options.bottomColor);
    }
  }

  function getOptionValue(index) {
    console.log(`🔍🔍🔍 [MuseStandBowl] 尝试获取选项 ${index}...`);
    
    if (isCustomizePage()) {
      // 🎯 先检查 window.selectedOptions 是否存在
      console.log(`   window.selectedOptions 状态:`, {
        '是否存在': typeof window.selectedOptions !== 'undefined',
        '是否为数组': Array.isArray(window.selectedOptions),
        '数组长度': window.selectedOptions?.length,
        [`选项${index}的值`]: window.selectedOptions?.[index]
      });
      
      // 🎯 优先从全局 selectedOptions 获取（更可靠）
      // 注意：不能用 window.selectedOptions[index] 作为判断条件，因为它可能是 null
      if (typeof window.selectedOptions !== 'undefined' && window.selectedOptions && index < window.selectedOptions.length) {
        const value = window.selectedOptions[index];
        if (value) {
          console.log(`✅ [MuseStandBowl] 从全局 selectedOptions 获取选项 ${index}:`, value);
          return value;
        } else {
          console.log(`⚠️ [MuseStandBowl] selectedOptions[${index}] 存在但值为空，尝试从DOM获取`);
        }
      } else {
        console.log(`⚠️ [MuseStandBowl] selectedOptions 不可用，尝试从DOM获取`);
      }
      
      // 尝试1: color-swatch
      console.log(`   尝试1: 查找 .color-swatch[data-index="${index}"].selected`);
      const swatch = document.querySelector(`.color-swatch[data-index="${index}"].selected`);
      console.log(`   找到的 swatch:`, swatch, swatch?.dataset?.value);
      if (swatch && swatch.dataset.value) {
        console.log(`✅ [MuseStandBowl] 从 color-swatch 获取选项 ${index}:`, swatch.dataset.value);
        return swatch.dataset.value;
      }
      
      // 尝试2: text-option
      console.log(`   尝试2: 查找 .text-option[data-index="${index}"].selected`);
      const textBtn = document.querySelector(`.text-option[data-index="${index}"].selected`);
      console.log(`   找到的 textBtn:`, textBtn, textBtn?.dataset?.value);
      if (textBtn && textBtn.dataset.value) {
        const value = textBtn.dataset.value;
        console.log(`✅ [MuseStandBowl] 从 text-option 获取选项 ${index}:`, value);
        return value;
      }
      
      // 尝试3: select下拉框
      console.log(`   尝试3: 查找 select[data-index="${index}"]`);
      const select = document.querySelector(`select[data-index="${index}"]`);
      console.log(`   找到的 select:`, select, select?.value);
      if (select && select.value) {
        console.log(`✅ [MuseStandBowl] 从 select 获取选项 ${index}:`, select.value);
        return select.value;
      }
      
      console.warn(`❌❌❌ [MuseStandBowl] 无法获取选项 ${index} 的值`);
      console.warn(`   所有尝试都失败了！`);
      return null;
    } else {
      // 尝试1: Globo插件选择器
      const globo = document.querySelector(`input[name="globo-option-${index}"]:checked`);
      if (globo) return globo.value;
      
      // 尝试2: 标准Shopify选择器（选项从1开始）
      const idx = index + 1;
      const std = document.querySelector(`input[name*="option${idx}"]:checked, input[name*="Option${idx}"]:checked`);
      if (std) return std.value;
      
      // 尝试3: select下拉框
      const stdSelect = document.querySelector(`select[name*="option${idx}"], select[name*="Option${idx}"]`);
      if (stdSelect && stdSelect.value) return stdSelect.value;
    }

    return null;
  }

  // ========== Finish可用性控制 ==========
  
  /**
   * 更新Finish选项的可用状态（仅适用于 MuseStand Bowl Set）
   */
  function updateFinishAvailability() {
    const productType = getProductType();
    
    // 🎯 AccoGift Feeding Set 不需要 Finish 可用性控制（第三个选项是 Mat Color）
    if (productType === 'accogift-feeding-set') {
      console.log('⏭️ [MuseStandBowl] AccoGift Feeding Set 跳过 Finish 可用性控制');
      return;
    }
    
    const topColor = getOptionValue(0);
    const bottomColor = getOptionValue(1);
    
    console.log('📝 [DEBUG] updateFinishAvailability 被调用');
    console.log('📝 [DEBUG] topColor原始值:', topColor);
    console.log('📝 [DEBUG] bottomColor原始值:', bottomColor);
    
    if (!topColor || !bottomColor) {
      console.log('🎯 [MuseStandBowl] 颜色未完全选择，跳过Finish更新');
      return;
    }
    
    console.log('🎯 [MuseStandBowl] 更新Finish可用性:', { topColor, bottomColor });
    
    // 检查ArenaFinishConfig是否已加载
    if (typeof window.ArenaFinishConfig === 'undefined') {
      console.warn('⚠️ [MuseStandBowl] ArenaFinishConfig未加载');
      return;
    }
    
    // MuseStand 双色碗：Black 和 Baby Yellow 支持 glossy 和 matte（与 Arena 不同）
    function isFinishComboAvailableMuseStand(tColor, bColor, tFinish, bFinish) {
      const key = function(c) {
        if (!c) return '';
        return String(c).toLowerCase().replace(/\s+/g, '');
      };
      const topKey = key(tColor);
      const bottomKey = key(bColor);
      const museStandBothFinish = ['black', 'babyyellow'];
      function supports(cKey, fin) {
        if (museStandBothFinish.indexOf(cKey) >= 0) return true;
        return window.ArenaFinishConfig.supportsFinish(cKey, fin);
      }
      return supports(topKey, tFinish) && supports(bottomKey, bFinish);
    }
    
    // 🎯 根据页面类型选择不同的选择器
    let finishElements = [];
    
    if (isCustomizePage()) {
      // Customize页面：使用 .text-option
      const buttons = document.querySelectorAll('.text-option[data-index="2"]');
      finishElements = Array.from(buttons).map(btn => ({
        element: btn,
        value: btn.dataset.value,
        type: 'customize'
      }));
      console.log(`🎯 [MuseStandBowl] Customize页面，找到 ${finishElements.length} 个Finish选项`);
    } else {
      // 产品页面：支持多种插件
      // 🎯 优先查找 Globo 插件的 Finish 选项（index=2）
      let radioButtons = document.querySelectorAll('input[name="globo-option-2"]');
      
      // 如果没找到Globo，查找标准Shopify的option3
      if (radioButtons.length === 0) {
        radioButtons = document.querySelectorAll('input[name*="option3"], input[name*="Option3"]');
      }
      
      finishElements = Array.from(radioButtons).map(radio => {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        return {
          element: radio,
          label: label,
          value: radio.value,
          type: 'product'
        };
      });
      console.log(`🎯 [MuseStandBowl] 产品页面，找到 ${finishElements.length} 个Finish选项`);
    }
    
    if (finishElements.length === 0) {
      console.log('⏭️ [MuseStandBowl] 未找到Finish按钮');
      return;
    }
    
    let hasAvailableOption = false;
    let firstAvailableElement = null;
    
    finishElements.forEach(item => {
      const finishValue = item.value;
      const finishes = parseFinishValue(finishValue);
      
      console.log(`📝 [DEBUG] 检查finish选项: ${finishValue}`);
      console.log(`📝 [DEBUG] 解析后: top=${finishes.top}, bottom=${finishes.bottom}`);
      
      // 检查这个组合是否可用（MuseStand：Black/BabyYellow 支持 glossy+matte）
      let isAvailable = isFinishComboAvailableMuseStand(
        topColor, 
        bottomColor, 
        finishes.top, 
        finishes.bottom
      );

      console.log(`  ${finishValue}: ${isAvailable ? '✅可用' : '❌不可用'}`);
      
      if (item.type === 'customize') {
        // Customize页面：直接操作按钮
        const btn = item.element;
        if (isAvailable) {
          btn.classList.remove('disabled');
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
          btn.style.pointerEvents = 'auto';
          
          hasAvailableOption = true;
          if (!firstAvailableElement) firstAvailableElement = item;
        } else {
          btn.classList.add('disabled');
          btn.classList.remove('selected');
          btn.style.opacity = '0.3';
          btn.style.cursor = 'not-allowed';
          btn.style.pointerEvents = 'none';
        }
      } else {
        // 产品页面：操作radio和label
        const radio = item.element;
        const label = item.label;
        
        if (isAvailable) {
          // 可用：移除禁用类和样式
          radio.classList.remove('is-unavailable');
          radio.disabled = false;
          if (label) {
            label.style.opacity = '1';
            label.style.cursor = 'pointer';
            label.style.pointerEvents = 'auto';
          }
          
          hasAvailableOption = true;
          if (!firstAvailableElement) firstAvailableElement = item;
        } else {
          // 不可用：添加禁用类和样式
          radio.classList.add('is-unavailable');
          radio.disabled = true;
          if (label) {
            label.style.opacity = '0.3';
            label.style.cursor = 'not-allowed';
            label.style.pointerEvents = 'none';
          }
        }
      }
    });
    
    // 如果当前选中的不可用，自动切换到第一个可用的
    const currentFinish = getOptionValue(2);
    if (currentFinish) {
      const currentFinishes = parseFinishValue(currentFinish);
      // 重新用 MuseStand 规则校验当前选中的 finish 是否可用
      const isCurrentAvailable = isFinishComboAvailableMuseStand(
        topColor, 
        bottomColor, 
        currentFinishes.top, 
        currentFinishes.bottom
      );
      
      if (!isCurrentAvailable && firstAvailableElement) {
        console.log('🔄 [MuseStandBowl] 当前Finish不可用，自动切换到:', firstAvailableElement.value);
        if (firstAvailableElement.type === 'customize') {
          firstAvailableElement.element.click();
        } else {
          firstAvailableElement.element.click();
        }
      }
    } else if (firstAvailableElement) {
      // 如果没有选中任何finish，自动选择第一个可用的
      console.log('🔄 [MuseStandBowl] 自动选择第一个可用Finish:', firstAvailableElement.value);
      firstAvailableElement.element.click();
    }
  }
  
  function updateImage() {
    console.log('[MuseStandBowl-DEBUG] update() 被调用，300ms 后执行 doUpdateImage');
    
    // 🎯 防抖：取消之前的更新请求
    if (updateTimer) {
      clearTimeout(updateTimer);
      console.log('⏭️ [MuseStandBowl] 取消之前的更新请求（防抖）');
    }
    
    // 延迟执行，避免多次触发
    updateTimer = setTimeout(doUpdateImage, 300);
  }

  function doUpdateImage() {
    console.log('[MuseStandBowl-DEBUG] doUpdateImage() 被调用');
    
    const shouldRunResult = shouldRun();
    if (!shouldRunResult) {
      console.log('[MuseStandBowl-DEBUG] 跳过原因: shouldRun() 返回 false（当前页面/产品不是 MuseStand 或 AccoGift Feeding Set）');
      return;
    }
    
    // 🎯 如果正在更新中，跳过
    if (isUpdating) {
      console.log('[MuseStandBowl-DEBUG] 跳过原因: 正在更新中 isUpdating=true');
      return;
    }
    
    // 🎯 在产品页面，先切换回第一个幻灯片
    if (!isCustomizePage()) {
      switchToFirstSlide();
    }
    
    const productType = getProductType();
    console.log('🥣 [MuseStandBowl] ========== 开始更新图片 ==========');
    console.log('🥣 [MuseStandBowl] 产品类型:', productType);
    
    const topColorOption = getOptionValue(0); // 例如: "White (Matte)" 或 "Black (Glossy)"
    const bottomColorOption = getOptionValue(1); // 例如: "White (Matte)" 或 "Black (Glossy)"
    const option2 = getOptionValue(2); // 可能是 Mat Color（AccoGift）或其他
    
    console.log('🥣🥣🥣 [MuseStandBowl] ========== 详细调试信息 ==========');
    console.log('🥣 [MuseStandBowl] 当前选项（原始值）:', { 
      '选项0_Top_Color': topColorOption, 
      '选项1_Bottom_Color': bottomColorOption, 
      '选项2_Mat_or_Finish': option2,
      '页面类型': isCustomizePage() ? 'Customize' : 'Product',
      '产品类型': productType
    });
    
    // 🎯 从颜色选项中解析颜色和 finish
    const topParsed = parseColorAndFinish(topColorOption);
    const bottomParsed = parseColorAndFinish(bottomColorOption);
    
    const topColor = topParsed.color;
    const topFinish = topParsed.finish;
    const bottomColor = bottomParsed.color;
    const bottomFinish = bottomParsed.finish;
    
    console.log('🎨 [MuseStandBowl] 解析后的颜色和finish:', {
      'Top原始值': topColorOption,
      'Top解析后': { color: topColor, finish: topFinish },
      'Bottom原始值': bottomColorOption,
      'Bottom解析后': { color: bottomColor, finish: bottomFinish }
    });
    
    // 🎯 根据产品类型处理选项
    let matColor, updateKey;
    
    if (productType === 'accogift-feeding-set') {
      // AccoGift Feeding Set: option2 是 Mat Color（第三个选项）
      matColor = option2;
      const normalizedMatColor = normalizeMatColor(matColor);
      updateKey = `${topColorOption}_${bottomColorOption}_${matColor}`;
      console.log('🎁 [MuseStandBowl] AccoGift模式 - 垫子颜色:', {
        '原始值': matColor,
        '标准化后': normalizedMatColor
      });
    } else {
      // MuseStand Bowl Set: 只有两个颜色选项（包含 finish）
      matColor = null;
      updateKey = `${topColorOption}_${bottomColorOption}`;
      console.log('🥣 [MuseStandBowl] MuseStand模式 - 无垫子');
    }
    
    // 🎯 生成唯一标识，检查是否与上次相同
    if (updateKey === lastUpdateKey) {
      console.log('[MuseStandBowl-DEBUG] 跳过原因: 选项与上次相同 updateKey=', updateKey);
      return;
    }
    
    // 检查必需选项
    if (!topColor || !bottomColor) {
        console.warn('[MuseStandBowl-DEBUG] 跳过原因: 颜色选项不完整', { topColor, bottomColor });
        lastUpdateKey = ''; // 重置
        
        // 🎯 如果在 Customize 页面且有 variant 图片，显示 variant 图片
        if (isCustomizePage() && window.currentMuseStandBowlVariant) {
          const variant = window.currentMuseStandBowlVariant;
          if (variant.featured_image && variant.featured_image.src) {
            console.log('✅ [MuseStandBowl] 使用 Variant 图片作为默认图');
            const img = document.querySelector('.custom-builder .main-image');
            if (img) {
              img.src = variant.featured_image.src;
            }
          }
        }
        
        return;
    }

    // AccoGift Feeding Set 需要 Mat Color
    if (productType === 'accogift-feeding-set' && !matColor) {
        console.warn('⚠️ [MuseStandBowl] 垫子颜色未选择，跳过更新');
        console.log('   提示: 请确保已选择 Feeding Mat Color');
      lastUpdateKey = ''; // 重置
      return;
    }
    
    // 🎯 标记为正在更新
    isUpdating = true;
    lastUpdateKey = updateKey;
    
    // 🎁 AccoGift Feeding Set: 使用图层叠加（碗+垫子）
    if (productType === 'accogift-feeding-set') {
      console.log('🎁 [MuseStandBowl] AccoGift Feeding Set - 使用图层叠加模式');
      // 构建 finish 字符串用于生成图片 URL
      const finishString = `${topFinish}+${bottomFinish}`;
      console.log('📝 [MuseStandBowl] 即将生成图片URL，参数:', {
        topColor,
        bottomColor,
        matColor,
        finishString
      });
      updateLayeredImage(topColor, bottomColor, matColor, finishString);
      return;
    }
    
    // 🥣 MuseStand Bowl Set: 使用单张图片（包含 finish）
    // 构建 finish 字符串用于生成图片 URL
    const finishString = `${topFinish}+${bottomFinish}`;
    const url = generateBowlImageUrl(topColor, bottomColor, finishString);
    if (!url) {
      console.error('❌ [MuseStandBowl] URL生成失败');
      lastUpdateKey = ''; // 重置
      isUpdating = false;
      return;
    }
    
    console.log('✅ [MuseStandBowl] CDN URL:', url);

    // 查找主图
    console.log('🔍 [MuseStandBowl] 开始查找主图片元素...');
    let mainImages = [];
    
    if (isCustomizePage()) {
        const img = document.querySelector('.custom-builder .main-image');
        if (img) {
          console.log('✅ [MuseStandBowl] Customize页面找到主图:', img.className);
          mainImages.push(img);
        } else {
          console.error('❌ [MuseStandBowl] Customize页面未找到 .main-image');
        }
    } else {
        // 产品页面：使用"最大可视面积"策略（从 EasyGo 借鉴）
        console.log('🔍 [MuseStandBowl] 产品页面，使用可视面积策略查找主图');
        
        let maxVisibleArea = 0;
        let bestImage = null;
        
        const allImages = document.querySelectorAll('img');
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        
        console.log(`🔍 [MuseStandBowl] 扫描 ${allImages.length} 张图片...`);
        
        // 🎯 策略1: 优先查找 layer-image.top-layer（兼容旧的图层系统）
        const topLayer = document.querySelector('.layer-image.top-layer, img.layer-image[class*="top"]');
        if (topLayer && topLayer.offsetWidth > 200 && topLayer.offsetHeight > 200) {
            const style = window.getComputedStyle(topLayer);
            if (style.opacity !== '0' && style.visibility !== 'hidden' && style.display !== 'none') {
                console.log('✅ [MuseStandBowl] 策略1成功 - 找到 layer-image.top-layer:', topLayer.className);
                bestImage = topLayer;
            }
        }
        
        // 🎯 策略2: 如果没找到 layer，使用"最大可视面积"
        if (!bestImage) {
            console.log('🔍 [MuseStandBowl] 策略1失败，使用策略2：计算可视面积...');
            
            allImages.forEach((img, idx) => {
                // 快速过滤小图标
                if (img.width < 200 || img.height < 200) return;
                
                const rect = img.getBoundingClientRect();
                
                // 计算与视口的交叉区域
                const intersectionLeft = Math.max(0, rect.left);
                const intersectionTop = Math.max(0, rect.top);
                const intersectionRight = Math.min(viewportWidth, rect.right);
                const intersectionBottom = Math.min(viewportHeight, rect.bottom);
                
                if (intersectionRight > intersectionLeft && intersectionBottom > intersectionTop) {
                    const visibleWidth = intersectionRight - intersectionLeft;
                    const visibleHeight = intersectionBottom - intersectionTop;
                    const visibleArea = visibleWidth * visibleHeight;
                    
                    const style = window.getComputedStyle(img);
                    const isVisible = style.opacity !== '0' && 
                                     style.visibility !== 'hidden' && 
                                     style.display !== 'none';
                    
                    if (isVisible && visibleArea > maxVisibleArea) {
                        maxVisibleArea = visibleArea;
                        bestImage = img;
                        
                        if (idx < 10) {  // 只打印前10个候选
                            console.log(`  候选[${idx}]: 可视面积=${Math.round(visibleArea)}px², class="${img.className}"`);
                        }
                    }
                }
            });
            
            if (bestImage) {
                console.log(`✅ [MuseStandBowl] 策略2成功 - 找到可视面积最大的图片 (${Math.round(maxVisibleArea)}px²)`);
                console.log(`   class: "${bestImage.className}", 尺寸: ${bestImage.width}x${bestImage.height}`);
            } else {
                console.error('❌ [MuseStandBowl] 策略2也失败 - 未找到任何可见主图');
            }
        }
        
        if (bestImage) {
            mainImages.push(bestImage);
        }
    }

    if (mainImages.length === 0) {
        console.error('[MuseStandBowl-DEBUG] 跳过原因: 未找到 .custom-builder .main-image 主图元素');
        isUpdating = false; // 重置标记
        return;
    }
    
    const img = mainImages[0];
    console.log('🔧 [MuseStandBowl] 准备更新图片元素:');
    console.log('   图片class:', img.className);
    console.log('   当前 src:', img.src);
    console.log('   目标 src:', url);
    console.log('   图片可见:', img.offsetWidth > 0 && img.offsetHeight > 0);
    console.log('   图片尺寸:', img.offsetWidth, 'x', img.offsetHeight);
    
    // 🎯 调试：列出页面上所有大尺寸图片
    const debugAllImages = document.querySelectorAll('img');
    const visibleLargeImages = Array.from(debugAllImages).filter(i => 
        i.offsetWidth > 200 && i.offsetHeight > 200 &&
        window.getComputedStyle(i).display !== 'none'
    );
    console.log(`🔍 [MuseStandBowl] 页面上共有 ${visibleLargeImages.length} 个可见的大尺寸图片`);
    visibleLargeImages.forEach((debugImg, idx) => {
        console.log(`   图片[${idx}]: class="${debugImg.className}", 是否为目标=${debugImg === img}`);
    });
    
    if (img.src === url && !img.hasAttribute('srcset')) {
        console.log('⏭️ [MuseStandBowl] 图片未变化，跳过更新');
        isUpdating = false; // 重置标记
        return;
    }
    
    console.log('🥣 [MuseStandBowl] 开始更新图片...');
    
    // 🎯 关键修复：隐藏所有可能叠加的图片
    console.log('🔧 [MuseStandBowl] 开始清理可能叠加的图片...');
    
    if (isCustomizePage()) {
        // Customize页面：特殊处理
        console.log('🔧 [MuseStandBowl] Customize页面模式 - 隐藏所有非目标图片');
        
        // 1. 隐藏 .product-image 容器内的所有其他图片
        const imageContainer = document.querySelector('.custom-builder .product-image');
        if (imageContainer) {
            const allImgsInContainer = imageContainer.querySelectorAll('img');
            console.log(`   找到容器内 ${allImgsInContainer.length} 个图片`);
            allImgsInContainer.forEach((containerImg, idx) => {
                if (containerImg !== img) {
                    containerImg.style.display = 'none';
                    containerImg.style.visibility = 'hidden';
                    console.log(`   🚫 隐藏容器内图片[${idx}]: ${containerImg.className}`);
                }
            });
        }
        
        // 2. 隐藏所有 layer-image（如果图层脚本添加了）
        const allLayerImages = document.querySelectorAll('.custom-builder .layer-image');
        if (allLayerImages.length > 0) {
            console.log(`   找到 ${allLayerImages.length} 个图层图片`);
            allLayerImages.forEach((layerImg, idx) => {
                if (layerImg !== img) {
                    layerImg.style.display = 'none';
                    layerImg.style.visibility = 'hidden';
                    console.log(`   🚫 隐藏图层[${idx}]: ${layerImg.className}`);
                }
            });
        }
        
        // 3. 🎯 激进策略：隐藏 custom-builder 内除目标外的所有大图片
        const allBuilderImages = document.querySelectorAll('.custom-builder img');
        let hiddenCount = 0;
        allBuilderImages.forEach((builderImg) => {
            if (builderImg !== img && builderImg.offsetWidth > 100 && builderImg.offsetHeight > 100) {
                builderImg.style.display = 'none';
                builderImg.style.visibility = 'hidden';
                builderImg.style.opacity = '0';
                hiddenCount++;
            }
        });
        if (hiddenCount > 0) {
            console.log(`   🚫 激进策略：隐藏了 ${hiddenCount} 个额外的图片`);
        }
        
        // 4. 确保目标图片可见并置顶
        img.style.display = 'block';
        img.style.visibility = 'visible';
        img.style.opacity = '1';
        img.style.position = 'relative';
        img.style.zIndex = '999';
        console.log('   ✅ 确保目标图片(.main-image)可见并置顶');
        
    } else {
        // 产品页面：原有逻辑
        console.log('🔧 [MuseStandBowl] 产品页面模式 - 隐藏图层和产品图片');
        
        // 1. 隐藏所有 layer-image（旧的图层系统）
        const allLayerImages = document.querySelectorAll('.layer-image');
        if (allLayerImages.length > 0) {
            console.log(`   找到 ${allLayerImages.length} 个图层图片`);
            allLayerImages.forEach((layerImg, idx) => {
                if (layerImg !== img) {
                    layerImg.style.display = 'none';
                    console.log(`   🚫 隐藏图层[${idx}]: ${layerImg.className}`);
                } else {
                    console.log(`   ✅ 保留目标图层[${idx}]: ${layerImg.className}`);
                }
            });
        }
        
        // 2. 隐藏页面上其他所有大尺寸的产品图片
        const allProductImages = document.querySelectorAll('.product__media-item img, .product-single__photo img, .product-gallery img');
        if (allProductImages.length > 0) {
            console.log(`   找到 ${allProductImages.length} 个产品图片容器`);
            allProductImages.forEach((prodImg, idx) => {
                if (prodImg !== img && prodImg.offsetWidth > 200) {
                    const parent = prodImg.closest('.product__media-item, .product-single__photo');
                    if (parent && parent !== img.closest('.product__media-item, .product-single__photo')) {
                        parent.style.display = 'none';
                        console.log(`   🚫 隐藏产品图片容器[${idx}]`);
                    } else if (prodImg !== img) {
                        prodImg.style.display = 'none';
                        console.log(`   🚫 隐藏产品图片[${idx}]`);
                    }
                }
            });
        }
    }
    
    // 先预加载图片，确保存在
    const testImg = new Image();
    testImg.onload = function() {
        console.log('✅ [MuseStandBowl] CDN图片预加载成功');
        console.log('📸 [DEBUG] 成功加载的URL:', url);
        
        // 启动保护机制
        startProtectingImage(img, url);
        
        // 淡出效果
        img.style.transition = 'opacity 0.3s ease';
        img.style.opacity = '0.5';
        
        setTimeout(() => {
            // 清理响应式图片属性
            if (img.hasAttribute('srcset')) {
              console.log('🔧 [MuseStandBowl] 移除 srcset');
              img.removeAttribute('srcset');
            }
            if (img.hasAttribute('sizes')) {
              console.log('🔧 [MuseStandBowl] 移除 sizes');
              img.removeAttribute('sizes');
            }
            if (img.hasAttribute('data-src')) img.removeAttribute('data-src');
            if (img.hasAttribute('data-srcset')) img.removeAttribute('data-srcset');
            if (img.loading === 'lazy') {
              console.log('🔧 [MuseStandBowl] 禁用懒加载');
              img.loading = 'eager';
            }
            
            // 更新 src
            img.src = url;
            
            // 🎯 确保当前图片可见
            img.style.display = '';
            img.style.visibility = 'visible';
            img.style.opacity = '1';
            
            // 强制重绘
            img.offsetHeight;
            
            console.log('✅ [MuseStandBowl] 图片已更新');
            console.log('   新 src:', img.src);
            console.log('   srcset已移除:', !img.hasAttribute('srcset'));
            
            // 🎯 重置更新标记
            isUpdating = false;
            
            // 验证更新是否成功
            setTimeout(() => {
              if (img.src === url) {
                console.log('✅ [MuseStandBowl] 验证通过：图片确实已更新');
                console.log('🥣 [MuseStandBowl] ========== 更新完成 ==========');
              } else {
                console.error('❌ [MuseStandBowl] 验证失败：图片被还原为', img.src);
                // 再次尝试
                img.src = url;
                img.removeAttribute('srcset');
                img.removeAttribute('sizes');
              }
            }, 500);
        }, 150);
    };
    
    testImg.onerror = function() {
        console.error('❌ [MuseStandBowl] CDN图片加载失败:', url);
        console.error('📸 [DEBUG] 失败的URL:', url);
        console.error('📸 [DEBUG] 颜色组合: top=' + topColor + ', bottom=' + bottomColor);
        
        // 🎯 如果是 AccoGift Feeding Set，尝试其他可能的文件名格式
        if (productType === 'accogift-feeding-set') {
          console.log('🎁 [MuseStandBowl] 尝试其他可能的文件名格式...');
          
          // 尝试 .png 格式
          const pngUrl = url.replace('.jpg', '.png');
          console.log('🎁 [MuseStandBowl] 尝试 PNG 格式:', pngUrl);
          
          const pngTestImg = new Image();
          pngTestImg.onload = function() {
            console.log('✅ [MuseStandBowl] PNG 格式图片加载成功');
            img.src = pngUrl;
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            isUpdating = false;
          };
          
          pngTestImg.onerror = function() {
            console.error('❌ [MuseStandBowl] PNG 格式也失败');
            console.log('💡 [MuseStandBowl] 请检查：');
            console.log('   1. 组合图片是否已上传到CDN');
            console.log('   2. 文件名格式是否正确: bowl1_top_{TopColor}_{TopFinish}_bottom_{BottomColor}_{BottomFinish}_mat_{MatColor}.jpg');
            console.log('   3. URL是否可访问');
            console.log('   4. 垫子颜色映射是否正确');
            
            // 🎯 重置更新标记
            isUpdating = false;
          };
          
          pngTestImg.src = pngUrl;
        } else {
        console.log('💡 [MuseStandBowl] 请检查：');
        console.log('   1. 图片是否已上传到CDN');
        console.log('   2. 文件名是否正确');
        console.log('   3. URL是否可访问');
        
        // 🎯 重置更新标记
        isUpdating = false;
        }
    };
    
    console.log('🔧 [MuseStandBowl] 预加载CDN图片...');
    testImg.src = url;
  }
  
  /**
   * 更新图层叠加图片（AccoGift Feeding Set: 碗+垫子）
   */
  function updateLayeredImage(topColor, bottomColor, matColor, finish) {
    console.log('🎁🎁🎁 [MuseStandBowl] ========== 开始图层叠加 ==========');
    console.log('🎁 [MuseStandBowl] 输入参数:', { topColor, bottomColor, matColor, finish });
    
    // 生成图片 URL（碗的图片包含 finish）
    const bowlUrl = generateBowlImageUrl(topColor, bottomColor, finish);
    const matUrls = generateMatImageUrl(matColor);
    
    console.log('🔗 [MuseStandBowl] 生成的URL:');
    console.log('   碗图片URL:', bowlUrl);
    console.log('   垫子图片URL(JPG):', matUrls?.jpg);
    console.log('   垫子图片URL(PNG):', matUrls?.png);
    
    if (!bowlUrl || !matUrls) {
      console.error('❌ [MuseStandBowl] 图片URL生成失败');
      console.error('   bowlUrl是否存在:', !!bowlUrl);
      console.error('   matUrls是否存在:', !!matUrls);
      isUpdating = false;
      return;
    }
    
    // 查找或创建图片容器
    let container = null;
    let bowlImg = null;
    let matImg = null;
    
    if (isCustomizePage()) {
      // Customize 页面
      container = document.querySelector('.custom-builder .product-image');
      if (!container) {
        console.error('❌ [MuseStandBowl] 未找到图片容器');
        isUpdating = false;
        return;
      }
      
      // 查找或创建并排容器
      let sideBySideContainer = container.querySelector('.accogift-side-by-side-container');
      // 🎯 使用 getElementById 更可靠地查找 productImageLink
      let productImageLink = document.getElementById('product-link');
      if (!productImageLink) {
        productImageLink = container.querySelector('.product-image-link');
      }
      const mainImg = productImageLink ? productImageLink.querySelector('.main-image') : container.querySelector('.main-image');
      
      if (!sideBySideContainer) {
        sideBySideContainer = document.createElement('div');
        sideBySideContainer.className = 'accogift-side-by-side-container';
        sideBySideContainer.style.display = 'flex';
        sideBySideContainer.style.flexDirection = 'row';
        sideBySideContainer.style.alignItems = 'center';
        sideBySideContainer.style.justifyContent = 'center';
        sideBySideContainer.style.gap = '0';
        sideBySideContainer.style.width = '100%';
        sideBySideContainer.style.visibility = 'visible';
        sideBySideContainer.style.opacity = '1';
        sideBySideContainer.style.position = 'relative';
        sideBySideContainer.style.left = '0';  // 🎯 确保不被移出视口
        sideBySideContainer.style.top = '0';
        sideBySideContainer.style.margin = '0 auto';  // 🎯 居中显示
        sideBySideContainer.style.padding = '0';
        
        // 获取原图尺寸
        if (mainImg) {
          const rect = mainImg.getBoundingClientRect();
          const computedStyle = window.getComputedStyle(mainImg);
          sideBySideContainer.style.width = rect.width > 0 ? rect.width + 'px' : (computedStyle.width || '100%');
          sideBySideContainer.style.height = rect.height > 0 ? rect.height + 'px' : (computedStyle.height || 'auto');
          sideBySideContainer.style.minHeight = rect.height > 0 ? rect.height + 'px' : '500px';
          console.log('🎁 [MuseStandBowl] 设置容器尺寸:', rect.width, 'x', rect.height);
        } else {
          // 如果没有原图，使用默认尺寸
          sideBySideContainer.style.width = '100%';
          sideBySideContainer.style.height = 'auto';
          sideBySideContainer.style.minHeight = '500px';
          console.log('🎁 [MuseStandBowl] 使用默认容器尺寸');
        }
        
        // 🎯 关键：直接替换原有图片链接
        console.log('🔍 [MuseStandBowl] 调试信息:');
        console.log('   container:', container);
        console.log('   productImageLink:', productImageLink);
        console.log('   mainImg:', mainImg);
        console.log('   container.children:', container.children);
        
        if (productImageLink) {
          // 将并排容器直接替换图片链接
          console.log('🎯 [MuseStandBowl] 准备替换 productImageLink');
          console.log('   productImageLink.parentNode:', productImageLink.parentNode);
          console.log('   productImageLink 在 DOM 中的位置:', productImageLink);
          productImageLink.replaceWith(sideBySideContainer);
          console.log('✅ [MuseStandBowl] 已替换 productImageLink');
          console.log('   替换后 container.children:', container.children);
        } else if (mainImg) {
          // 如果没有链接，直接替换图片
          console.log('🎯 [MuseStandBowl] 准备替换 mainImg');
          console.log('   mainImg.parentNode:', mainImg.parentNode);
          mainImg.replaceWith(sideBySideContainer);
          console.log('✅ [MuseStandBowl] 已替换 mainImg');
        } else {
          // 如果都没有，添加到容器开头（确保在最上面）
          console.log('🎯 [MuseStandBowl] 未找到原图，插入到容器开头');
          if (container.firstChild) {
            container.insertBefore(sideBySideContainer, container.firstChild);
          } else {
            container.appendChild(sideBySideContainer);
          }
          console.log('✅ [MuseStandBowl] 已插入到容器开头');
        }
        console.log('✅ [MuseStandBowl] 创建并排容器（直接替换原图）');
      } else {
        // 如果容器已存在，检查它是否在正确的位置
        console.log('🔍 [MuseStandBowl] 容器已存在，检查位置');
        console.log('   sideBySideContainer.parentNode:', sideBySideContainer.parentNode);
        console.log('   sideBySideContainer 在 DOM 中的位置:', sideBySideContainer);
        const rect = sideBySideContainer.getBoundingClientRect();
        console.log('   容器位置:', rect.top, rect.left, rect.width, rect.height);
        
        // 🎯 确保容器样式正确，不被移出视口
        sideBySideContainer.style.position = 'relative';
        sideBySideContainer.style.left = '0';
        sideBySideContainer.style.top = '0';
        sideBySideContainer.style.margin = '0 auto';
        
        // 如果容器不在 product-image 容器内，重新插入
        if (!container.contains(sideBySideContainer)) {
          console.log('⚠️ [MuseStandBowl] 容器不在正确位置，重新插入');
          if (productImageLink) {
            productImageLink.replaceWith(sideBySideContainer);
          } else if (mainImg) {
            mainImg.replaceWith(sideBySideContainer);
          } else {
            if (container.firstChild) {
              container.insertBefore(sideBySideContainer, container.firstChild);
            } else {
              container.appendChild(sideBySideContainer);
            }
          }
        }
      }
      
      // 查找或创建碗的图片容器
      let bowlWrapper = sideBySideContainer.querySelector('.accogift-bowl-wrapper');
      if (!bowlWrapper) {
        bowlWrapper = document.createElement('div');
        bowlWrapper.className = 'accogift-bowl-wrapper';
        bowlWrapper.style.flex = '1';
        bowlWrapper.style.display = 'flex';
        bowlWrapper.style.alignItems = 'center';
        bowlWrapper.style.justifyContent = 'center';
        bowlWrapper.style.position = 'relative';
        sideBySideContainer.appendChild(bowlWrapper);
      }
      
      // 查找或创建碗的图片
      bowlImg = bowlWrapper.querySelector('.accogift-bowl-image');
      if (!bowlImg) {
        bowlImg = document.createElement('img');
        bowlImg.className = 'accogift-bowl-image';
        bowlImg.style.width = '100%';
        bowlImg.style.height = 'auto';
        bowlImg.style.maxWidth = '100%';
        bowlImg.style.objectFit = 'contain';
        bowlImg.style.display = 'block';
        bowlImg.style.visibility = 'visible';
        bowlImg.style.opacity = '0';
        bowlImg.style.transition = 'opacity 0.3s ease';
        bowlWrapper.appendChild(bowlImg);
        console.log('✅ [MuseStandBowl] 创建碗图片元素');
      }
      
      // 查找或创建垫子的图片容器
      let matWrapper = sideBySideContainer.querySelector('.accogift-mat-wrapper');
      if (!matWrapper) {
        matWrapper = document.createElement('div');
        matWrapper.className = 'accogift-mat-wrapper';
        matWrapper.style.flex = '1';
        matWrapper.style.display = 'flex';
        matWrapper.style.alignItems = 'center';
        matWrapper.style.justifyContent = 'center';
        matWrapper.style.position = 'relative';
        sideBySideContainer.appendChild(matWrapper);
      }
      
      // 查找或创建垫子的图片
      matImg = matWrapper.querySelector('.accogift-mat-image');
      if (!matImg) {
        matImg = document.createElement('img');
        matImg.className = 'accogift-mat-image';
        matImg.style.width = '100%';
        matImg.style.height = 'auto';
        matImg.style.maxWidth = '100%';
        matImg.style.objectFit = 'contain';
        matImg.style.display = 'block';
        matImg.style.visibility = 'visible';
        matImg.style.opacity = '0';
        matImg.style.transition = 'opacity 0.3s ease';
        matWrapper.appendChild(matImg);
        console.log('✅ [MuseStandBowl] 创建垫子图片元素');
      }
      
    } else {
      // 产品页面：使用覆盖层方法
      const mainImageContainer = document.querySelector('.main-image');
      
      if (!mainImageContainer) {
        console.error('❌ [MuseStandBowl] 未找到主图容器');
        isUpdating = false;
        return;
      }
      
      console.log('✅ [MuseStandBowl] 使用覆盖层方法');
      
      // 确保 main-image 容器有相对定位
      mainImageContainer.style.position = 'relative';
      
      // 查找或创建覆盖层容器（放在 main-image 上而不是 slider item 内）
      let sideBySideContainer = mainImageContainer.querySelector('.accogift-side-by-side-container');
      if (!sideBySideContainer) {
        sideBySideContainer = document.createElement('div');
        sideBySideContainer.className = 'accogift-side-by-side-container';
        sideBySideContainer.style.cssText = `
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 0;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 0;
          padding: 0;
          z-index: 100;
          background-color: #fff;
          pointer-events: none;
        `;
        
        mainImageContainer.appendChild(sideBySideContainer);
        console.log('✅ [MuseStandBowl] 已创建覆盖层容器');
      } else {
        // 容器已存在，确保正确显示
        sideBySideContainer.style.display = 'flex';
        sideBySideContainer.style.visibility = 'visible';
        sideBySideContainer.style.opacity = '1';
      }
      
      // 设置容器为当前容器（用于后续创建图片元素）
      container = sideBySideContainer;
      
      // 查找或创建碗的图片容器
      let bowlWrapper = sideBySideContainer.querySelector('.accogift-bowl-wrapper');
      if (!bowlWrapper) {
        bowlWrapper = document.createElement('div');
        bowlWrapper.className = 'accogift-bowl-wrapper';
        bowlWrapper.style.flex = '1';
        bowlWrapper.style.display = 'flex';
        bowlWrapper.style.alignItems = 'center';
        bowlWrapper.style.justifyContent = 'center';
        bowlWrapper.style.position = 'relative';
        sideBySideContainer.appendChild(bowlWrapper);
      }
      
      // 查找或创建碗的图片
      bowlImg = bowlWrapper.querySelector('.accogift-bowl-image');
      if (!bowlImg) {
        bowlImg = document.createElement('img');
        bowlImg.className = 'accogift-bowl-image';
        bowlImg.style.width = '100%';
        bowlImg.style.height = 'auto';
        bowlImg.style.maxWidth = '100%';
        bowlImg.style.objectFit = 'contain';
        bowlWrapper.appendChild(bowlImg);
        console.log('✅ [MuseStandBowl] 创建碗图片元素');
      }
      
      // 查找或创建垫子的图片容器
      let matWrapper = sideBySideContainer.querySelector('.accogift-mat-wrapper');
      if (!matWrapper) {
        matWrapper = document.createElement('div');
        matWrapper.className = 'accogift-mat-wrapper';
        matWrapper.style.flex = '1';
        matWrapper.style.display = 'flex';
        matWrapper.style.alignItems = 'center';
        matWrapper.style.justifyContent = 'center';
        matWrapper.style.position = 'relative';
        sideBySideContainer.appendChild(matWrapper);
      }
      
      // 查找或创建垫子的图片
      matImg = matWrapper.querySelector('.accogift-mat-image');
      if (!matImg) {
        matImg = document.createElement('img');
        matImg.className = 'accogift-mat-image';
        matImg.style.width = '100%';
        matImg.style.height = 'auto';
        matImg.style.maxWidth = '100%';
        matImg.style.objectFit = 'contain';
        matWrapper.appendChild(matImg);
        console.log('✅ [MuseStandBowl] 创建垫子图片元素');
      }
    }
    
    // 确保容器可见（使用正确的容器变量名）
    const sideBySideContainer = document.querySelector('.accogift-side-by-side-container');
    if (sideBySideContainer) {
      sideBySideContainer.style.display = 'flex';
      sideBySideContainer.style.visibility = 'visible';
      sideBySideContainer.style.opacity = '1';
    }
    
    // 加载碗的图片
    console.log('🎁 [MuseStandBowl] 加载碗图片:', bowlUrl);
    const bowlTestImg = new Image();
    bowlTestImg.onload = function() {
      console.log('✅ [MuseStandBowl] 碗图片预加载成功');
      bowlImg.src = bowlUrl;
      bowlImg.style.display = 'block';
      bowlImg.style.visibility = 'visible';
      bowlImg.style.opacity = '1';
      bowlImg.removeAttribute('srcset');
      bowlImg.removeAttribute('sizes');
      console.log('🎁 [MuseStandBowl] 碗图片已设置，src:', bowlImg.src);
      
      // 加载垫子的图片
      console.log('🎁 [MuseStandBowl] 加载垫子图片:', matUrls.jpg);
      const matTestImg = new Image();
      
      matTestImg.onload = function() {
        console.log('✅ [MuseStandBowl] 垫子图片预加载成功');
        matImg.src = matTestImg.src;
        matImg.style.display = 'block';
        matImg.style.visibility = 'visible';
        matImg.style.opacity = '1';
        matImg.removeAttribute('srcset');
        matImg.removeAttribute('sizes');
        console.log('🎁 [MuseStandBowl] 垫子图片已设置，src:', matImg.src);
        
        // 验证图片是否真的显示
        setTimeout(() => {
          const bowlRect = bowlImg.getBoundingClientRect();
          const matRect = matImg.getBoundingClientRect();
          console.log('🎁 [MuseStandBowl] 图片尺寸验证:');
          console.log('   碗图片:', bowlRect.width, 'x', bowlRect.height, 'opacity:', window.getComputedStyle(bowlImg).opacity);
          console.log('   垫子图片:', matRect.width, 'x', matRect.height, 'opacity:', window.getComputedStyle(matImg).opacity);
        }, 100);
        
          console.log('✅ [MuseStandBowl] 图层叠加完成');
          console.log('🎁 [MuseStandBowl] ========== 图层叠加完成 ==========');
          // 🎯 确保覆盖层显示
          showOverlay();
          isUpdating = false;
      };
      
      matTestImg.onerror = function() {
        // 尝试 PNG 格式
        console.log('🎁 [MuseStandBowl] JPG 失败，尝试 PNG 格式:', matUrls.png);
        const pngTestImg = new Image();
        pngTestImg.onload = function() {
          console.log('✅ [MuseStandBowl] 垫子图片（PNG）预加载成功');
          matImg.src = pngTestImg.src;
          matImg.style.display = 'block';
          matImg.style.visibility = 'visible';
          matImg.style.opacity = '1';
          matImg.removeAttribute('srcset');
          matImg.removeAttribute('sizes');
          console.log('✅ [MuseStandBowl] 图层叠加完成');
          // 🎯 确保覆盖层显示
          showOverlay();
          isUpdating = false;
        };
        pngTestImg.onerror = function() {
          console.error('❌ [MuseStandBowl] 垫子图片加载失败（JPG 和 PNG 都失败）');
          isUpdating = false;
        };
        pngTestImg.src = matUrls.png;
      };
      
      matTestImg.src = matUrls.jpg;
    };
    
    bowlTestImg.onerror = function() {
      console.error('❌❌❌ [MuseStandBowl] 碗图片加载失败!');
      console.error('   URL:', bowlUrl);
      console.error('   颜色组合:', {
        'Top Color': topColor,
        'Bottom Color': bottomColor,
        'Finish': finish
      });
      console.error('💡 可能的原因:');
      console.error('   1. 这个颜色组合的图片不存在');
      console.error('   2. 颜色名称映射错误');
      console.error('   3. CDN文件名格式不匹配');
      alert(`碗图片加载失败！\n\n颜色组合：\nTop: ${topColor}\nBottom: ${bottomColor}\nFinish: ${finish}\n\n需要的文件：\nbowl1_top_${topColor}_${finish.split('+')[0]}_bottom_${bottomColor}_${finish.split('+')[1]}.jpg`);
      isUpdating = false;
    };
    
    bowlTestImg.src = bowlUrl;
  }
  
  let imageObserver = null;
  function startProtectingImage(img, targetUrl) {
      if (imageObserver) imageObserver.disconnect();
      
      let isRestoring = false; // 防止无限循环
      
      imageObserver = new MutationObserver((mutations) => {
          if (isRestoring) return; // 如果正在还原，跳过
          
          mutations.forEach(m => {
              if (m.type === 'attributes' && m.attributeName === 'src') {
                  if (img.src !== targetUrl) {
                      console.log('🛡️ [MuseStandBowl] 检测到src被修改，还原图片');
                      isRestoring = true;
                      img.src = targetUrl;
                      img.removeAttribute('srcset');
                      setTimeout(() => { isRestoring = false; }, 100);
                  }
              }
              
              if (m.type === 'attributes' && m.attributeName === 'srcset') {
                  if (img.hasAttribute('srcset')) {
                      console.log('🛡️ [MuseStandBowl] 检测到srcset被添加，移除');
                      isRestoring = true;
                      img.removeAttribute('srcset');
                      setTimeout(() => { isRestoring = false; }, 100);
                  }
              }
          });
      });
      
      imageObserver.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
      console.log('🛡️ [MuseStandBowl] 图片保护已启动');
  }
  
  function stopProtectingImage() {
      if (imageObserver) {
          imageObserver.disconnect();
          imageObserver = null;
          console.log('🛡️ [MuseStandBowl] 图片保护已停止');
      }
  }

  // 🎯 当前活动的幻灯片索引（用于跟踪缩略图切换）
  let currentSlideIndex = 0;
  // 记录第一个slider item的media-id（这是自定义图片应该显示的位置）
  let firstSlideMediaId = null;

  /**
   * 🎯 显示覆盖层
   */
  function showOverlay() {
    if (isCustomizePage()) return;
    
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return;
    
    const overlay = mainImageContainer.querySelector('.accogift-side-by-side-container');
    if (overlay) {
      overlay.style.display = 'flex';
      overlay.style.visibility = 'visible';
      overlay.style.opacity = '1';
      console.log('✅ [MuseStandBowl] 显示覆盖层');
    }
  }

  /**
   * 🎯 隐藏覆盖层
   */
  function hideOverlay() {
    if (isCustomizePage()) return;
    
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return;
    
    const overlay = mainImageContainer.querySelector('.accogift-side-by-side-container');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.style.visibility = 'hidden';
      overlay.style.opacity = '0';
      console.log('✅ [MuseStandBowl] 隐藏覆盖层');
    }
  }

  /**
   * 🎯 检查当前是否在第一个幻灯片
   */
  function checkIsFirstSlideActive() {
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return false;
    
    const firstSliderItem = mainImageContainer.querySelector('.slider__item:first-child');
    return firstSliderItem && firstSliderItem.classList.contains('is-active');
  }

  /**
   * 🎯 切换到第一个幻灯片
   */
  function switchToFirstSlide() {
    if (isCustomizePage()) return;
    
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return;
    
    const firstSliderItem = mainImageContainer.querySelector('.slider__item:first-child');
    if (!firstSliderItem || firstSliderItem.classList.contains('is-active')) {
      showOverlay();
      return;
    }
    
    // 使用 MediaGallery 的 setActiveMedia 方法
    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery && firstSliderItem.dataset.mediaId) {
      if (typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(firstSliderItem.dataset.mediaId, true);
        console.log('✅ [MuseStandBowl] 已切换到第一个幻灯片');
        setTimeout(showOverlay, 100);
        return;
      }
    }
    
    // 备用方法：点击缩略图
    const firstThumbnail = document.querySelector('.thumbnails .slider__item:first-child .thumbnail');
    if (firstThumbnail) {
      firstThumbnail.click();
      setTimeout(showOverlay, 100);
    }
  }

  /**
   * 🎯 处理缩略图切换 - 方案A：点击缩略图或滑动时隐藏覆盖层，显示原始图片
   * 只有选择选项时才显示拼图
   */
  function handleThumbnailSwitch(mediaId, slideIndex) {
    if (!shouldRun()) return;
    if (isCustomizePage()) return;
    
    console.log('🥣 [MuseStandBowl] 缩略图切换，索引:', slideIndex);
    
    // 🎯 方案A：手动切换到任何幻灯片时隐藏覆盖层，显示原始图片
    hideOverlay();
    
    currentSlideIndex = slideIndex;
  }

  /**
   * 🎯 初始化第一个幻灯片的 media-id
   */
  function initFirstSlideMediaId() {
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return;
    
    const firstSliderItem = mainImageContainer.querySelector('.slider__item');
    if (firstSliderItem) {
      firstSlideMediaId = firstSliderItem.dataset.mediaId;
      console.log('🥣 [MuseStandBowl] 记录第一个幻灯片 media-id:', firstSlideMediaId);
    }
  }

  function init() {
    console.log('🥣 [MuseStandBowl] ========== 初始化开始 ==========');
    
    if (!shouldRun()) {
      console.log('⏭️ [MuseStandBowl] 初始化跳过（不是目标产品）');
      return;
    }
    
    const productType = getProductType();
    console.log('✅ [MuseStandBowl] 确认为目标产品，开始初始化...');
    console.log('   产品类型:', productType);
    console.log('   页面类型:', isCustomizePage() ? 'Customize页面' : '产品页面');
    console.log('   页面URL:', window.location.href);
    
    // 🎯 初始化第一个幻灯片的 media-id
    initFirstSlideMediaId();
    
    // 🎯 防止重复绑定：检查是否已经绑定过
    if (!document.body.dataset.musestandBowlBound) {
        document.body.dataset.musestandBowlBound = 'true';
        
        // 绑定点击事件（使用事件委托）
        document.body.addEventListener('click', function(e) {
            if (!shouldRun()) return; // 只在MuseStand Bowl产品时响应
            
            if (e.target.closest('.color-swatch') || 
                e.target.closest('.text-option') || 
                e.target.matches('input[type="radio"]') ||
                e.target.matches('label[for*="option"]')) {
                console.log('🥣 [MuseStandBowl] 检测到选项点击');
                
                // 如果是颜色选项(index 0或1)，且是 MuseStand Bowl Set，更新Finish可用性
                const productType = getProductType();
                if (productType === 'musestand-bowl') {
                const target = e.target.closest('.color-swatch') || e.target.closest('.text-option');
                if (target && target.dataset.index) {
                  const optionIndex = parseInt(target.dataset.index);
                  if (optionIndex === 0 || optionIndex === 1) {
                    console.log('🎯 [MuseStandBowl] 颜色选项变化，延迟更新Finish可用性');
                    setTimeout(updateFinishAvailability, 100);
                    }
                  }
                }
                
                updateImage(); // 直接调用（已有防抖）
            }
        }, true); // 使用捕获阶段，确保最先触发
        console.log('✅ [MuseStandBowl] 已绑定点击事件监听器');
        
        // 绑定change事件
        document.body.addEventListener('change', function(e) {
            if (!shouldRun()) return; // 只在MuseStand Bowl产品时响应
            
            if (e.target.matches('select') || e.target.matches('input[type="radio"]')) {
                console.log('🥣 [MuseStandBowl] 检测到选项变化:', e.target.value);
                
                // 检查是否是颜色选项（仅 MuseStand Bowl Set）
                const productType = getProductType();
                if (productType === 'musestand-bowl') {
                const name = e.target.name || '';
                // 🎯 产品页面: option1-option, option2-option (从1开始)
                // 🎯 Customize页面: option0, option1 (从0开始) 或 globo-option-0, globo-option-1
                if (name.includes('option1') || name.includes('option2') ||
                    name.includes('Option1') || name.includes('Option2') ||
                    name.includes('option0') || name.includes('Option0') ||
                    name.includes('globo-option-0') || name.includes('globo-option-1')) {
                  console.log('🎯 [MuseStandBowl] 颜色选项变化，延迟更新Finish可用性');
                  setTimeout(updateFinishAvailability, 100);
                  }
                }
                
                updateImage(); // 直接调用（已有防抖）
            }
        }, true); // 使用捕获阶段
        console.log('✅ [MuseStandBowl] 已绑定change事件监听器');
        
        // 🎯 监听缩略图点击事件
        document.body.addEventListener('click', function(e) {
            if (!shouldRun()) return;
            if (isCustomizePage()) return;
            
            const thumbnail = e.target.closest('.thumbnail');
            if (thumbnail) {
                const sliderItem = thumbnail.closest('.slider__item');
                if (sliderItem) {
                    const mediaId = sliderItem.dataset.mediaId;
                    const allItems = Array.from(document.querySelectorAll('.thumbnails .slider__item'));
                    const slideIndex = allItems.indexOf(sliderItem);
                    
                    console.log('🥣 [MuseStandBowl] 检测到缩略图点击:', { mediaId, slideIndex });
                    
                    // 延迟处理，等待 MediaGallery 完成切换
                    setTimeout(() => {
                        handleThumbnailSwitch(mediaId, slideIndex);
                    }, 100);
                }
            }
        }, false);
        console.log('✅ [MuseStandBowl] 已绑定缩略图点击监听器');
        
        // 🎯 监听轮播滑动事件
        const mediaGallery = document.querySelector('media-gallery');
        if (mediaGallery) {
            const section = mediaGallery.closest('.js-product');
            if (section) {
                section.addEventListener('on:carousel-slider:select', function(e) {
                    if (!shouldRun()) return;
                    if (isCustomizePage()) return;
                    
                    const slideIndex = e.detail.index;
                    const slide = e.detail.slide;
                    const mediaId = slide ? slide.dataset.mediaId : null;
                    
                    console.log('🥣 [MuseStandBowl] 检测到轮播滑动:', { mediaId, slideIndex });
                    
                    setTimeout(() => {
                        handleThumbnailSwitch(mediaId, slideIndex);
                    }, 50);
                });
                console.log('✅ [MuseStandBowl] 已绑定轮播滑动监听器');
                
                // 🎯 关键：监听变体变化事件，在 MediaGallery 切换之后强制切换回第一个幻灯片
                section.addEventListener('on:variant:change', function(e) {
                    if (!shouldRun()) return;
                    if (isCustomizePage()) return;
                    
                    console.log('🥣 [MuseStandBowl] 检测到变体变化事件');
                    
                    // 延迟执行，确保在 MediaGallery 的 onVariantChange 之后运行
                    setTimeout(() => {
                        console.log('🥣 [MuseStandBowl] 强制切换回第一个幻灯片');
                        switchToFirstSlide();
                        
                        // 再次延迟显示覆盖层，确保切换完成
                        setTimeout(showOverlay, 150);
                    }, 200);
                });
                console.log('✅ [MuseStandBowl] 已绑定变体变化监听器');
            }
        }
    } else {
        console.log('⏭️ [MuseStandBowl] 事件监听器已存在，跳过绑定');
    }
    
    // Customize页面：监听选项区域变化（仅限首次加载）
    if (isCustomizePage()) {
        const wrapper = document.getElementById('product-option-groups');
        if (wrapper) {
            console.log('✅ [MuseStandBowl] 找到选项容器，启动MutationObserver（仅首次）');
            let hasInitialized = false;
            const obs = new MutationObserver((mutations) => {
                // 🎯 只在首次检测到选项添加时触发一次
                if (!hasInitialized && shouldRun()) {
                    const hasNewOptions = mutations.some(m => 
                        m.addedNodes.length > 0 && 
                        Array.from(m.addedNodes).some(n => 
                            n.classList && (n.classList.contains('color-swatch') || n.classList.contains('text-option'))
                        )
                    );
                    
                    if (hasNewOptions) {
                        console.log('👀 [MuseStandBowl] 检测到选项首次加载');
                        hasInitialized = true;
                        setTimeout(() => {
                            updateFinishAvailability();
                            updateImage();
                        }, 500);
                    }
                }
            });
            obs.observe(wrapper, { childList: true, subtree: true });
        } else {
            console.warn('⚠️ [MuseStandBowl] 未找到 #product-option-groups 容器');
        }
        
        // 监听产品切换
        const productSelect = document.getElementById('product-select');
        if (productSelect) {
            productSelect.addEventListener('change', function() {
                console.log('🔄 [MuseStandBowl] 检测到产品切换');
                setTimeout(() => {
                    if (shouldRun()) {
                        const productType = getProductType();
                        console.log('🔄 [MuseStandBowl] 切换到目标产品，重新初始化，产品类型:', productType);
                        setTimeout(() => {
                            // 只有 MuseStand Bowl Set 需要更新 Finish 可用性
                            if (productType === 'musestand-bowl') {
                            updateFinishAvailability();
                            }
                            updateImage();
                        }, 500);
                    }
                }, 300);
            });
            console.log('✅ [MuseStandBowl] 已绑定产品切换监听器');
        }
    }

    // 初始更新（延迟执行，确保DOM完全加载）
    console.log('🔧 [MuseStandBowl] 1秒后执行首次图片更新...');
    setTimeout(() => {
        console.log('🔧 [MuseStandBowl] 执行首次图片更新');
        const productType = getProductType();
        // 只有 MuseStand Bowl Set 需要更新 Finish 可用性
        if (productType === 'musestand-bowl') {
        updateFinishAvailability();
        }
        updateImage();
    }, 1000);
    
    console.log('✅ [MuseStandBowl] 初始化完成');
    console.log('🥣 [MuseStandBowl] ========== 初始化结束 ==========');
  }
  
  window.MuseStandBowl = {
    update: updateImage,
    updateFinishAvailability: updateFinishAvailability,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 500);
  }

  console.log('🥣 [MuseStandBowl] 脚本加载完成，等待初始化');

})();


